<div class="page_toolbar" *ngIf="!totalCount">
  <h3 class="title_page">
    {{"surveyTasks.surveyAnswersAndResponses"|translate}}
  </h3>
</div>
<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>
<div *ngIf="!dataLoading">
  <ng-container *ngIf="recordsData && recordsData.length; else noResponse">
    <div class="custom_card">
      <div class="card_header">
        <h4>{{"surveyTasks.surveyAnswersAndResponses"|translate}}</h4>
        <button type="button" mat-button color="primary" (click)="addResponse()" *ngIf="canAddResponse && totalCount"
          [disabled]="dataLoading">
          <span>{{"surveyTasks.addResponse"|translate}}</span>
        </button>
      </div>
      <div class="card_body">
        <div class="responses_table_wrapper table-responsive" *ngIf="totalCount">
          <table class="responses_table w-100">
            <thead>
              <tr>
                <th class="col_check" *ngIf="!isAmbassador">
                  <mat-checkbox [checked]="allSelected" [indeterminate]="someSelected"
                    (change)="toggleAll($event.checked)">
                  </mat-checkbox>
                </th>
                <th>{{"surveyTasks.responseNumber"|translate}}</th>
                <th>{{"surveyTasks.responseEntryDate"|translate}}</th>
                <th>{{"surveyTasks.status"|translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of recordsData">
                <td class="col_check" *ngIf="!isAmbassador">
                  <mat-checkbox [disabled]="!record.canSeletetAllRespondent" [checked]="isSelected(record)"
                    (change)="toggleOne(record, $event.checked)">
                  </mat-checkbox>
                </td>
                <td class="fw-bold" dir="ltr">
                  <a class="primary" (click)="openDetails(record.respondentsId)">
                    {{ record.responseNumber }}
                  </a>
                </td>
                <td>{{ record.submittedDate | date:'d MMM yyyy - h:mm a' }}</td>
                <td>
                  <span [ngSwitch]="record.status">
                    <span class="badge-status-text purple" *ngSwitchCase="SurveyOpinionResposnseStatusEnum.Submitted">
                      {{"evaluationTasks.new"|translate}}
                    </span>
                    <span class="badge-status-text success" *ngSwitchCase="SurveyOpinionResposnseStatusEnum.Approved">
                      {{"surveyTasks.approved"|translate}}
                    </span>
                    <span class="badge-status-text red_2" *ngSwitchCase="SurveyOpinionResposnseStatusEnum.Rejected">
                      {{"manageSurveys.excludedByReviewer"|translate}}
                    </span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="text-center mt-5" *ngIf="pageNumber <= pageCount - 1">
      <button mat-raised-button class="mat-primary-light" (click)="getNextPage()" [class.loading]='loading' [disabled]='loading'>
        {{ "general.showMore" | translate}}
      </button>
    </div>
  </ng-container>
  <ng-template #noResponse>
    <empty-state [img]="'assets/images/no-evaluatio-tasks.png'" [hideTitle]="true"
      [desc]='"surveyTasks.noResponseAddedYet"|translate' (eventEmit)="addResponse()"
      [link]="'surveyTasks.addResponse'|translate" [linkBoolean]="canAddResponse"></empty-state>
  </ng-template>
</div>

<app-surveys-tasks-response-details *ngIf="selectedRecordId" (close)="selectedRecordId = null;"
  [selectedRecordId]="selectedRecordId" [taskId]="details.taskId"></app-surveys-tasks-response-details>
